import constantes from '../helpers/constanteHelper'

function TituloNegrito({texto}) {
    return (
        <h1 className='mt-5 mb-5 me-2 ms-2' style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>{texto}</h1>
    );
}

export default TituloNegrito;
